$(document).ready(function () {
           const container = document.getElementById('mapid')
           if(container == null) {	
				        console.log("called before initializing mapid")				
				        return;
				   }	
				   console.log("called initializing mapid")				
           var $geolocation_x = $('#my_service_geomap_x_location');
           var x_location = $geolocation_x.val();
           if (!x_location) return;
				   console.log("geolocation_x=",x_location)

           var $geolocation_y = $('#my_service_geomap_y_location');
           var y_location = $geolocation_y.val();
           if (!y_location) return;
				   console.log("geolocation_y=",y_location)
				
				
            var map = L.map('mapid').setView([y_location, -x_location], 17);

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);

            L.marker([y_location, x_location]).addTo(map)
                .bindPopup('I am here.<br> Looking for service.')
                .openPopup();


            var circle = L.circle([y_location, x_location], {
                color: 'red',
                fillColor: '#f03',
                fillOpacity: 0.5,
                radius: 5
            }).addTo(map);


});


$(document).ready(function () {
        const container = document.getElementById('map')
        if(container == null) {	
				   console.log("called before initializing map")				
				   return;
				}	
				console.log("called initializing map")
		let prev_latitude = null;
		let prev_longitude = null;					
	    var startMarker;	            
        var $geolocation_x = $('#my_service_geomap_x_location');
        var x_location = $geolocation_x.val();
        if (!x_location) return;
				console.log("geolocation_x=",x_location)

        var $geolocation_y = $('#my_service_geomap_y_location');
        var y_location = $geolocation_y.val();
        if (!y_location) return;
				console.log("geolocation_y=",y_location)

        var $my_order_token = $('#my_service_order_token');
        var order_token = $my_order_token.val();
        if (!order_token) return;
				console.log("order_token=",order_token);
				
        var map_init = L.map('map', {
            center: [y_location, x_location],
            zoom: 8
        });
        var osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map_init);
        L.Control.geocoder().addTo(map_init);
        if (!navigator.geolocation) {
            console.log("Your browser doesn't support geolocation feature!")
        } else {
            //setInterval(() => {
            //    navigator.geolocation.getCurrentPosition(getPosition)
            //}, 10000);
			
			startMarker = L.layerGroup();
			lc = L.control
			  .locate({
				layer: startMarker,  
				strings: {
				  title: "Show me where I am, yo!"
				}
			  })
			  .addTo(map_init);		
			map_init.on('locationfound', onLocationFound);
			map_init.on('locationerror', onLocationError);			  
        };
		
		function onLocationError(e) {
		  console.log(e.message);
		}		
		function onLocationFound(e) {
			var locationLayers = startMarker.getLayers();			  
			if (locationLayers.length === 0) {
			  console.log('startpoint not defined');
			} else {
			  // Last position should be represented by one of the last layers
			  // (there may be several layers on same position, should you
			  // have enabled circle and/or compass)
			  var positionMarker = locationLayers[locationLayers.length - 1];
			  // Do something with positionMarker.getLatLng()...
			if(prev_latitude != positionMarker.getLatLng().lat || prev_longitude != positionMarker.getLatLng().lng){
				//  send your location to server
				console.log("Yeah.. Your current coordinate is: Lat: " + positionMarker.getLatLng().lat + " Long: " + positionMarker.getLatLng().lng + " Accuracy: " + e.accuracy)	
				console.log("Yeah.. Your prev coordinate is: Lat: " + prev_latitude + " Long: " + prev_longitude + " Accuracy: " + e.accuracy)
				prev_latitude = positionMarker.getLatLng().lat
				prev_longitude = positionMarker.getLatLng().lng	
			      var data1 = {'latitude': positionMarker.getLatLng().lat,
     				'longitude': positionMarker.getLatLng().lng,
     			    'token': order_token,					
					};
				  return;
				  $.ajax({
					url: $('html').data('auto-current-location-url'),
					method: 'POST',
					data: data1,
					success: (response) => {
					  console.log("current location Sucess")
					  console.log(response.success)
					  window.location=response.url	
					},
					error: (response) => {
					  console.log(response.error)
					  console.log("current location Error")
					}
				  });				
			}else{
				console.log("Yeah.. Your current coordinate is same again: Lat: " + positionMarker.getLatLng().lat + " Long: " + positionMarker.getLatLng().lng + " Accuracy: " + e.accuracy)					
			}			  
			}  
		}  
        var marker, circle, lat, long, accuracy;

        function getPosition(position) {
            // console.log(position)
            lat = position.coords.latitude
            long = position.coords.longitude
            accuracy = position.coords.accuracy

            if (marker) {
                map_init.removeLayer(marker)
            }

            if (circle) {
                map_init.removeLayer(circle)
            }

            marker = L.marker([lat, long])
            circle = L.circle([lat, long], { radius: accuracy })

            var featureGroup = L.featureGroup([marker, circle]).addTo(map_init)

            map_init.fitBounds(featureGroup.getBounds())

            console.log("Your current coordinate is: Lat: " + lat + " Long: " + long + " Accuracy: " + accuracy)
        }

});